export default __webpack_public_path__ + "static/media/js.ab65e723.png";